module.exports = __webpack_public_path__ + "static/banner-mobile-1d7b20ac10b3bee99a938592923bf7a1.jpg";